import { keyBy } from "lodash";
/**
 * Returns the min and max items from a collection, using `iteratee` to extract
 * the comparison value and `comparator` to compare them.
 *
 * If all items are equal, the first item is returned as both the min and max.
 *
 * @param collection - An iterable to search.
 * @param iteratee - The function to extract the comparison value from each item.
 * @param comparator - The function to compare the comparison values.
 *
 * @returns The min and max items, or [undefined, undefined] if the collection is empty.
 */
export function findExtremesBy(collection, iteratee, comparator = (a, b) => (a < b ? -1 : a > b ? 1 : 0)) {
    let minItem, maxItem = undefined;
    let minValue, maxValue = undefined;
    for (const item of collection) {
        if (minItem === undefined && maxItem === undefined) {
            minItem = maxItem = item;
            minValue = maxValue = iteratee(item);
            continue;
        }
        const value = iteratee(item);
        if (comparator(value, minValue) < 0) {
            minValue = value;
            minItem = item;
        }
        else if (comparator(value, maxValue) > 0) {
            maxValue = value;
            maxItem = item;
        }
    }
    return [minItem, maxItem];
}
export function arrayToMapByUid(inputNodes) {
    return keyBy(inputNodes, (n) => n.uid ?? "");
}
//# sourceMappingURL=collection.js.map